import { eq, range, length } from './util'

export class Point {
  constructor(readonly x: number, readonly y: number) {}

  scale(s: number): Point {
    return new Point(this.x * s, this.y * s)
  }

  map(f: (a: number) => number) {
    return new Point(f(this.x), f(this.y))
  }

  hashCode(): number {
    let result = this.x
    result = 31 * result + this.y;
    return result;
  }

  negate(): Point {
    return new Point(-this.x, -this.y)
  }

  toString(): string {
    return `(${this.x}, ${this.y})`
  }
}

// epsilon equals
export function equals(p0: Point, p1: Point): boolean {
  return (eq(p0.x, p1.x) && eq(p0.y, p1.y))
}

export function distance(p0: Point, p1: Point): number {
  return length(p1.x - p0.x, p1.y - p0.y)
}

export function neighbors(p: Point, d: number = 1): Point[] {
  const ps: Point[] = []
  const width = 2 * d + 1
  const ns = range(width).map(i => i - d)
  for (const y of ns) {
    for (const x of ns) {
      ps.push(new Point(p.x + x, p.y + y))
    }
  }

  return ps
}
